var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyToClipboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.78,
    height: 25.961,
    viewBox: "0 0 23.78 25.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5719",
    "data-name": "Rectangle 5719",
    width: 23.78,
    height: 25.961,
    fill: "#747474"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7258",
    "data-name": "Group 7258",
    transform: "translate(-781.646 -681.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7254",
    "data-name": "Group 7254",
    transform: "translate(781.646 681.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7252",
    "data-name": "Group 7252",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17762",
    "data-name": "Path 17762",
    d: "M64.017,9.7q0-3.4,0-6.791a2.77,2.77,0,0,1,.667-1.794,2.849,2.849,0,0,1,1.4-.966,2.34,2.34,0,0,1,.639-.117q4.26-.024,8.521-.03c.993,0,1.985-.014,2.977,0a3,3,0,0,1,1.87.573A2.946,2.946,0,0,1,81.2,2.245a4.261,4.261,0,0,1,.1.954q.01,6.576,0,13.152a3.172,3.172,0,0,1-.281,1.408A2.8,2.8,0,0,1,79.1,19.339a3.845,3.845,0,0,1-.887.124q-5.556.012-11.112.006a3.151,3.151,0,0,1-1.368-.28,3,3,0,0,1-1.376-1.321,3.043,3.043,0,0,1-.347-1.5q0-3.332,0-6.664Z",
    transform: "translate(-57.524 0)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17763",
    "data-name": "Path 17763",
    d: "M19.454,69.026c0,.109,0,.2,0,.293,0,.519.014,1.039,0,1.558a3.028,3.028,0,0,1-.881,2.151,3.152,3.152,0,0,1-1.53.806,2.677,2.677,0,0,1-.633.055c-4.451,0-8.9,0-13.354.007a3.088,3.088,0,0,1-1.826-.567A3.065,3.065,0,0,1,.154,71.855,2.787,2.787,0,0,1,0,70.841q0-6.43,0-12.86C0,57.394,0,56.807.008,56.22a2.919,2.919,0,0,1,.728-1.838,3.082,3.082,0,0,1,1.848-1.015,1.867,1.867,0,0,1,.365-.022c.591,0,1.182,0,1.774,0,.11,0,.142.031.142.143q-.007,5.429-.009,10.858a4.843,4.843,0,0,0,.134,1.21,4.6,4.6,0,0,0,.649,1.428A4.7,4.7,0,0,0,7.8,68.733a3.007,3.007,0,0,0,.975.242c.313.018.626.049.939.049q4.776.005,9.553,0Z",
    transform: "translate(0 -47.935)",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M4.049,13.293.175,9.418a.6.6,0,0,1,0-.843l.843-.843a.6.6,0,0,1,.843,0l2.61,2.61,5.59-5.59a.6.6,0,0,1,.843,0l.843.843a.6.6,0,0,1,0,.843L4.892,13.293A.6.6,0,0,1,4.049,13.293Z",
    transform: "translate(791.438 682.397)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboardIcon);
export default __webpack_public_path__ + "static/media/copy-to-clipboard-icon.c2aeb618706772a450bcc4efc9416fe6.svg";
export { ForwardRef as ReactComponent };